import React from "react";
import Grid from '@mui/material/Grid2';
import { Box, Typography, useMediaQuery} from "@mui/material";
import Button from './Button';
import { FirstSectionProps } from "../../interfaces";



const FirstSection: React.FC<FirstSectionProps> = ({
  // Content with defaults
  icon,
  iconAlt = "Icon",
  title = "Are you an agent or a business with a strong network?",
  description = "From acquiring, payment gateway services and API integrations to a ready-made e-wallet, currency exchange and bank transfers",
  heading = "become <br/> an affiliated partner",
  mobileHeading = "",
  buttonText = "CONTACT US",
  buttonVariant = "lightPurple",
  buttonHref = "#contact",
  
  // Styling with defaults
  backgroundImage,
  backgroundColor = "darkPurple.500",
  titleColor = "beige.800",
  descriptionColor = "beige.800",
  headingColor = "beige.100",
  
  // Optional custom styles
  containerSx,
  leftColumnSx,
  rightColumnSx,
  iconSx,
  headingStyle,
  
  // Column sizing with defaults
  leftColumnSize = { xs: 12, md: 5 },
  rightColumnSize = { xs: 12, md: 7 },
}) => {
  const isMobile = useMediaQuery('(max-width: 991px)');

  const displayHeading = isMobile && mobileHeading !== "" ? mobileHeading : heading;

  return (
    <Box sx={{
      display: "flex",
      maxWidth: "1440px",
      width: "100%",
      margin: "0 auto",
      px: 1.5,
      flexDirection: "column",
      alignItems: "center",
      alignSelf: "stretch",
      ...containerSx
    }}>
      <Grid container spacing={1} width={"100%"}>
        <Grid size={leftColumnSize} sx={{
          display: "flex",
          borderRadius: "12px",
          flexDirection: "column",
          alignItems: {md: "flex-start", xs: "flex-end"},
          gap: {md:"10px", xs: "64px"},
          alignSelf: "stretch",
          minHeight: {xs: "246px", md: "712px"},
          justifyContent: {md: "space-between", xs: "flex-start"},
          order: {xs: 2, md: 1},
          padding: {xs: "24px 20px", md: "48px"},
          flex: "1 0 0",
          ...leftColumnSx
        }}>
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: {md: "32px", xs: "20px"},
            alignItems: "flex-start",
            alignSelf: "stretch",
          }}>
            {icon && (
              <Box 
                component="img" 
                src={icon} 
                alt={iconAlt}
                sx={{
                  width: {md: "80px", xs: "60px"},
                  height: {md: "80px", xs: "60px"},
                  ...iconSx
                }} 
              />
            )}
            {title && (
              <Typography variant="subtitle10" sx={{
                color: titleColor
              }}>
                <Box 
                  component="span" 
                  dangerouslySetInnerHTML={{__html: typeof title === 'string' ? title : ''}}
                />
              </Typography>
            )}
          </Box>
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: {md: "32px", xs: "24px"},
            alignItems: "flex-start",
            alignSelf: "stretch",
          }}>
            {description && (
              <Typography variant="body7" sx={{
                color: descriptionColor,
                textTransform: "uppercase",
              }}>
                {description}
              </Typography>
            )}
            {buttonText && (
              <Button 
                variant={buttonVariant}
                href={buttonHref}
              >
                {buttonText}
              </Button>
            )}
          </Box>
        </Grid>
        
        <Grid size={rightColumnSize} sx={{ 
          backgroundColor: backgroundColor, 
          borderRadius: "12px",
          order: {xs: 1, md: 2},
          ...rightColumnSx
        }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: {md: "flex-end", xs: "flex-start"},
              justifyContent: "flex-end",
              padding: {md: "48px", xs: "20px"},
              alignSelf: "stretch",
              minHeight: { md: "712px", xs: "246px" },
              backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
              backgroundSize: "cover",
            }}
          >   
            {heading && (
              <Typography variant="h6" sx={{
                color: headingColor,
                textAlign: "right",
                ...headingStyle
              }}>
                <Box 
                  component="span" 
                  dangerouslySetInnerHTML={{__html: typeof displayHeading === 'string' ? displayHeading : ''}}
                />
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FirstSection;